import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "./mfaPopup.css";
import Button from "../ThemeButton/ThemeButton";
import PropTypes from "prop-types";

const MfaPopup = ({
  show,
  setShow,
  alertMessage,
  handleSubmitData,
  modalTitle = "Enter the Code",
  handleCancelClick,
  buttonSubmitText,
  onClickReSend,
  code,
  setCode,
  mfaType,
}) => {
  // const [code, setCode] = useState(["", "", "", "", "", ""]); // 6 inputs
  const inputRefs = useRef([]);

  const handleInputChange = (value, index) => {
    if (/^\d?$/.test(value)) {
      // Allow only numbers
      const updatedCode = [...code];
      updatedCode[index] = value;
      setCode(updatedCode);

      // Move focus to the next input
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      // Move focus to the previous input on backspace
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").slice(0, 6); // Limit to 6 characters
    const updatedCode = pasteData
      .split("")
      .map((char) => (/\d/.test(char) ? char : ""));
    setCode(updatedCode);

    // Move focus to the appropriate input
    updatedCode.forEach((_, i) => {
      if (inputRefs.current[i]) inputRefs.current[i].focus();
    });
  };

  return (
    <div>
      <Modal show={show} className="alertBoxModal">
        <div className="contentContainerConfirmAlert mfaPopup">
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
            <div className="modalBody">{alertMessage}</div>
          </Modal.Header>
          <div className="inputGroup" onPaste={handlePaste}>
            {code.map((num, index) => (
              <input
                key={index}
                type="text"
                value={num}
                maxLength="1"
                ref={(el) => (inputRefs.current[index] = el)}
                onChange={(e) => handleInputChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                className={`mfaInput ${num ? "filled" : ""}`}
              />
            ))}
          </div>
          <div className="mfaTextGrp">
            {mfaType === "Email" && (
              <div>
                <span>{"Didn’t get the code?"}</span>
                <span className="resendText" onClick={onClickReSend}>
                  {" Click to resend"}
                </span>
              </div>
            )}
            {/* <span className="resendText" onClick={onClickReSend}>
              {"Click to resend"}
            </span> */}
          </div>
          <Modal.Footer>
            <div className="buttonOk">
              <div className="cancelBtns">
                <Button value="Cancel" onClick={handleCancelClick}></Button>
              </div>
              <Button
                value={buttonSubmitText}
                onClick={() => handleSubmitData(code.join(""))}
              ></Button>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
};

export default MfaPopup;
